<template>
  <div class="index">
    <Header></Header>
    <main id="content" role="main" class="overflow-hidden">
        <!-- Hero 头部结构 -->
        <div class="gradient-y-gray position-relative">
          <div class="space-top-3 space-bottom-2 space-bottom-lg-3">
            <div class="container mt-lg-11">
              <!-- Content -->
              <div class="row">
                <div class="col-lg-7 col-xl-6">
                  <div class="mb-5">
                    <h1 class="display-5">超越创新，探索未来</h1>
                    <p class="lead">为客户提供融合创新，面向未来的信息化、智能化、可视化数据挖潜与运营支撑服务。</p>
                  </div>

                  <!-- Fancybox -->
                  <a class="js-fancybox video-player video-player-btn media align-items-center text-dark" href="javascript:;"
                    data-hs-fancybox-options='{
                      "src":"http://39.101.166.52:8888/file/视频/68e06f1654773657029000.mp4",
                      "caption": "数据可视化（Data- visualization）",
                      "speed": 700,
                      "buttons": ["fullScreen", "close"],
                      "youtube": {
                        "autoplay": 1
                      }
                    }'>
                    <span class="video-player-icon shadow-soft mr-3">
                      <i class="fa fa-play"></i>
                    </span>
                    <span class="media-body">
                      观看业务演示
                    </span>
                  </a>
                  <!-- End Fancybox -->
                </div>
              </div>
              <!-- End Content -->
            </div>

            <div class="transform-rotate-5">
              <div class="d-none d-lg-flex flex-lg-wrap align-items-lg-end position-absolute top-0 left-50 transform-rotate-6" style="width: 45rem;">
                <!-- Device Mockup -->
                <div class="device device-horizontal-ipad mr-4 mb-4" style="width: 23rem;" data-aos="fade-up" data-aos-delay="150" data-aos-offset="-300">
                  <img class="device-horizontal-ipad-frame" src="@/assets/svg/components/ipad-horizontal.svg" alt="Image Description">
                  <img class="device-horizontal-ipad-screen" src="@/assets/img/wepb/1.webp" alt="Image Description">
                </div>
                <!-- End Device Mockup -->

                <!-- Device Mockup -->
                <div class="device device-ipad mb-4" style="width: 19rem;" data-aos="fade-up">
                  <img class="device-ipad-frame" src="@/assets/svg/components/ipad.svg" alt="Image Description">
                  <img class="device-ipad-screen" src="@/assets/img/wepb/4.webp" alt="Image Description">
                </div>
                <!-- End Device Mockup -->

                <!-- Device Mockup -->
                <div class="device device-iphone-x align-self-start" style="width: 7rem;" data-aos="fade-up" data-aos-delay="250" data-aos-offset="-300">
                  <img class="device-iphone-x-frame" src="@/assets/svg/components/iphone-x.svg" alt="Image Description">
                  <img class="device-iphone-x-screen" src="@/assets/img/wepb/5.webp" alt="Image Description">
                </div>
                <!-- End Device Mockup -->

                <!-- Device Mockup -->
                <div class="device mr-4" style="width: 35rem;" data-aos="fade-up" data-aos-delay="200" data-aos-offset="-300">
                  <img class="img-fluid" src="@/assets/svg/components/macbook.svg" alt="Image Description">
                  <img class="device-macbook-screen" src="@/assets/img/wepb/2.webp" alt="Image Description">
                </div>
                <!-- End Device Mockup -->

                <!-- SVG Shape -->
                <figure class="max-w-23rem w-100 position-absolute bottom-0 left-0 z-index-n1" data-aos="fade-up" data-aos-delay="300" data-aos-offset="-400">
                  <div class="mb-n7 ml-n11">
                    <img class="img-fluid" src="@/assets/svg/components/abstract-shapes-10.svg" alt="Image Description">
                  </div>
                </figure>
                <!-- End SVG Shape -->
              </div>
            </div>
          </div>

          <!-- SVG Bottom Shape -->
          <figure>
            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
              <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
            </svg>
          </figure>
          <!-- End SVG Bottom Shape -->
        </div>
        <!-- End Hero 头部结构 -->

    <!-- 技术与能力 -->
    <div class="container space-2">
      <!-- Title -->
      <div class="w-md-100 w-lg-60 text-center mx-md-auto mb-9">
        <h2 class="divider divider-text">{{ jntitle }}</h2>
        <h2 class="h">{{ jnsubtitle }}</h2>
      </div>
      <!-- End Title -->

      <div class="row justify-content-lg-center">
       
        <div class="col-md-6 mb-6" v-for="(item, index) in this.jnlist" :key="index">
          <!-- Icon Blocks -->
          <div class="media pr-lg-5" style="cursor:pointer" @click="goDetail(item)">
            <figure class="w-100 max-w-8rem mr-4">
              <img class="img-fluid" :src="getImgUrl(item.fileId)" alt="SVG">
            </figure>
            <div class="media-body">
              <h4>{{ item.title }}</h4>
              <!-- <p>{{ item.subtitle }}</p> -->
              <p v-html="item.content"></p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>
      </div>
    </div>
    <!-- End 技术与能力 -->

   

    <!-- 解决方案 -->
    <div class="container space-2">
      <!-- Title -->
      <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
        <h2 class="divider divider-text">{{ fatitle }}</h2>
        <h2 class="h">{{ fasubtitle }}</h2>
      </div>
      <!-- End  -->

      <div class="row">
        <div class="col-sm-6 col-md-4 mb-5" v-for="item in contentList1"  :key="item.contentId">
          <!-- Card Info -->
          <div class="card h-100" @click="skip(item.contentId)" style="cursor:pointer;">
            <img class="card-img-top" :src="getImgUrl(item.imgsrc)" alt="Image Description">
            <div class="card-body">
              <p class="mb-0"><h4>{{item.title}}</h4></p>
              <p class="mb-0">{{item.subtitle}}</p>
            </div>
            <div class="card-footer">
              <a class="font-weight-bold" style="cursor:pointer;color:#0052ea" >查看方案 <i class="fas fa-angle-right fa-sm ml-1"></i></a>
            </div>
          </div>
          <!-- End Card Info -->
        </div>
      </div>
    </div>
    <!-- End 解决方案 -->

    <!-- 合作企业 -->
    <div class="container space-2" style="padding-bottom: 4rem!important">
      <div class="w-lg-75 mx-lg-auto">
        <div class="text-center mb-4">
        <h2 class="divider divider-text">{{ hztitle }}</h2>
        </div>

        <div class="row justify-content-between text-center">
          <div class="col-4 col-lg-2 mb-5 mb-lg-0"  v-for="(item, index) in logolist" :key="index">
            <div class="mx-3" >
              <img class="max-w-11rem max-w-md-13rem mx-auto" :src="imgsrc + item.fileId" alt="Image Description">
            </div>
          </div>
        </div>
      </div>
    </div>

    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //16
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //17
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.css"; //18
import "@/assets/vendor/aos/dist/aos.css"; //19
import "@/assets/css/theme.css"; //20
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.js"; //8
import "@/assets/vendor/appear.js"; //9
import "@/assets/vendor/circles/circles.min.js"; //10
import AOS from "aos";
// import 'aos/dist/aos.css' //11

// import 'bootstrap'
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3
import "@/assets/js/hs.core.js"; //12
import "@/assets/js/hs.fancybox.js"; //13

import "@/assets/js/hs.circles.js"; //14
import "@/assets/vendor/hs-counter/dist/hs-counter.min.js"; //15
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import { getsy, getsycolumn, getPostDetail, getsyres } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      defautid: "", // 默认首页id
      imgsrc: process.env.NODE_URL + "api/files/getFileStream?fileId=",
      jntitle: "", // 技能标题
      jnsubtitle: "", // 技能子标题
      jnlist: [], // 技能数组
      hxtitle: "", // 核心标题
      hxDEVS: [], // 核心产品DEVS?
      hximg:null,
      hxlist: [], // 核心数组
      fatitle: "", // 解决方案标题
      fasubtitle: "", //解决方案子标题
      hztitle: "", // 合作企业
      logolist: [], // 合作企业
      collist:[],
      contentList:[],
      contentList1:[]
    };
  },
  created() {
    this.getMore()
    getsycolumn(0).then((res) => {
      console.log(res);
      let arr = res.data;
      console.log(396, arr);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].title == "首页") {
          if (this.$route.query.id) {
            this.defautid = this.$route.query.id;
          } else {
            this.defautid = arr[i].columnId;
          }
          getsycolumn(this.defautid).then((mes) => {
            let arr1 = [];
            arr1 = mes.data;
            console.log(407, arr1);
            for (let j = 0; j < arr1.length; j++) {
              if (arr1[j].type == "技术与能力") {
                this.jntitle = arr1[j].title;
                this.jnsubtitle = arr1[j].subtitle;
                getsy(arr1[j].columnId).then((Res) => {
                  this.jnlist = Res.data.content;
                  let arr = Res.data.content
                  arr.forEach((item,index)=>{
                    this.getlogoimg(item.contentId,item,index)
                  })
                  console.log(418, this.jnlist);

                });
              }
              if (arr1[j].type == "核心产品与服务") {
                getsy(arr1[j].columnId).then((Res) => {
                  this.hxtitle = arr1[j].title;
                  this.hxDEVS = Res.data.content[0];
                  console.log(this.hxDEVS);
                  this.hxlist = Res.data.content
                  this.hxlist.splice(0,1)
                  console.log(431,this.hxlist);
                });
              }
              if (arr1[j].type == "解决方案") {
                this.fatitle = arr1[j].title;
                this.fasubtitle = arr1[j].subtitle;
              }
              if (arr1[j].type == "合作企业") {
                this.hztitle = arr1[j].title
                this.getlogo(arr1[j].columnId)
              }
            }
          });
        }
      }
    });
  },
  methods: {
    getlogo(a) {
      getsy(a).then(res => {
        let arr = res.data.content
        this.getlogoimg(arr[0].contentId);
      })
    },
    getlogoimg(a,obj,index) {
      getsyres(a).then(res => {
        let arr = res.data;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].keystring == "小图") {
            this.logolist.push(arr[i]);
            console.log(324, this.logolist);
          }
          if(arr[i].keystring == "核心"){
            this.hximg = arr[i].fileId
          }
          if(arr[i].keystring == "技术能力"){
            obj.fileId = arr[i].fileId;
            this.$set(this.jnlist,index,obj)

          }
        }
      })
    },
    // 获取更多
    getMore(){
      getsycolumn(0).then(res=>{
        let arr = res.data
        arr.forEach(item=>{
          if(item.type == "行业方案"){
            this.collist.push(item.columnId)
            getsycolumn(item.columnId).then(hs=>{
              let ar1 = hs.data
              ar1.forEach(ts=>{this.collist.push(ts.columnId)})
              this.getMoreContent(this.collist)
            })
          }
        })
      })
    },
    // 通过栏目id查询内容
    getMoreContent(arr){
      getPostDetail(arr).then(res=>{
        this.contentList = res.data
        let z =0
        console.log(res)
        this.contentList.forEach((item,i)=>{
          if(z>=3){return}else{
            z = z +1
            this.getImgResouce(item,item.contentId )
          }
        })
      })
    },
    // 通过内容id获取资源
    getImgResouce(obj,id){
      getsyres(id).then(res=>{
        let arr = res.data
        if(arr && arr.length>0){
          arr.forEach(hs=>{if(hs.keystring == "封面"){obj.imgsrc = hs.fileId;this.contentList1.push(obj)}})
        }
      })
    },
    // 图片地址
    getImgUrl(id){
      return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
    },
    skip(id){
      this.detalContent = null
      this.contentList1 = [];
      this.contentList = [];
      this.$router.push({path:'/plan',query:{contentId:id}})
    },
    goDetail(obj){
        this.$router.push({path:"/plan",query:{columnId:obj.subtitle}})
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
};
</script>

<style scoped>
.index {
  margin: auto;
}
.display-5 {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.lead {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
a {
  text-decoration: none;
}
.divider-text {
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.mb-9 .h,
.mb-md-7 .h,
.mb-md-9 .h {
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.875rem;
  line-height: 1.4;
}
.media-body h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.media-body p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.mb-md-7 p,
.pr-lg-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788 !important;
}
.card-body h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-body .mb-0 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.col-md-6 {
  padding: 0 25px;
}
.pr-lg-5 {
  padding: 0 2rem;
}
.space-2 {
  padding-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue